(function () {
  const modal = document.querySelector('.phy-blog-articles-cta-modal');
  if (!modal) return;

  const closeBtn = modal.querySelector('.modal__close');
  document.querySelectorAll(`[data-micromodal-trigger="${modal.id}"]`).forEach((trigger) => {
    trigger.addEventListener('click', () => {
      requestAnimationFrame(() => closeBtn.focus());
    });
  });
}());
